var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSmileyGood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 64C17.5 64 4 50.5 4 34C4 17.5 17.5 4 34 4C50.5 4 64 17.5 64 34C64 50.5 50.5 64 34 64Z",
    fill: "#B1D4F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7054 45.0938C26.6964 45.0938 19.7143 39.7031 17.25 31.5094L21.3571 30.2156C23.2054 36.2531 28.5446 40.7812 34.5 40.7812C40.6607 40.7812 46 36.2531 47.6429 30L51.75 31.2938C49.6964 39.7031 42.7143 45.0938 34.7054 45.0938Z",
    fill: "#0000C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 22C32 20.4087 31.3679 18.8826 30.2426 17.7574C29.1174 16.6321 27.5913 16 26 16C24.4087 16 22.8826 16.6321 21.7574 17.7574C20.6321 18.8826 20 20.4087 20 22L23.5075 22C23.5075 21.3389 23.7701 20.705 24.2375 20.2375C24.705 19.7701 25.3389 19.5075 26 19.5075C26.6611 19.5075 27.295 19.7701 27.7625 20.2375C28.2299 20.705 28.4925 21.3389 28.4925 22H32Z",
    fill: "#0000C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 22C48 20.4087 47.3679 18.8826 46.2426 17.7574C45.1174 16.6321 43.5913 16 42 16C40.4087 16 38.8826 16.6321 37.7574 17.7574C36.6321 18.8826 36 20.4087 36 22L39.5539 22C39.5539 21.3512 39.8116 20.7291 40.2703 20.2703C40.7291 19.8116 41.3512 19.5539 42 19.5539C42.6488 19.5539 43.2709 19.8116 43.7297 20.2703C44.1884 20.7291 44.4461 21.3512 44.4461 22H48Z",
    fill: "#0000C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmileyGood);
export default __webpack_public_path__ + "static/media/icon-smiley-good.4fa3e0aec7b396f3df7b9c52a3a053a7.svg";
export { ForwardRef as ReactComponent };